import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { endpoints, fetcher } from 'services';
import { INIT_PAGESIZE } from 'commons/constants';

const useStudentHistory = (student: string, phone: string, searchParams: any) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [historyList, setHistoryList] = useState<StudentHistoryListDto[]>();
  const [searchResult, setSearchResult] = useState({ pageNo: 0, pageSize: INIT_PAGESIZE, totalCount: 0 });

  /* ======================================================
   * hooks
   * ====================================================== */

  const { isLoading, refetch } = useQuery(
    [endpoints.b2c.student.history, searchParams],
    () =>
      fetcher.b2c.postStudentHistoryList({
        pageNo: Number(searchParams.pageNo) || 1,
        pageSize: Number(searchParams.pageSize) || INIT_PAGESIZE,
        student: student,
        phone: phone,
        searchValue: searchParams.search ? String(searchParams.search) : '',  
        searchDateStart: searchParams.searchDateStart ? String(searchParams.searchDateStart) : '',   
        searchDateEnd: searchParams.searchDateEnd ? String(searchParams.searchDateEnd) : '',  
        company: searchParams.company ? String(searchParams.company) : '',   
      }),
    {
      onSuccess: (res: CommonSearchListResDto) => {
        switch (res.code) {
          case 200:
            setHistoryList(res.result?.list);
            setSearchResult({
              pageNo: res.result?.pageNo || 1,
              pageSize: res.result?.pageSize || INIT_PAGESIZE,
              totalCount: res.result?.totalCount || 0,
            });
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { historyList, searchResult, refetch };
};

export default useStudentHistory;
